import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'
import { Button } from '@/ui/components'
import { getServices } from '@/ui/core/services'
import { strings } from './GoogleAuthButton.strings'
import googleIcon from '@/assets/google-icon.svg'

const StyledButton = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 400px;
  gap: 10px;
  font-size: 14px;
  line-height: 20px;
  font-family: 'Roboto', arial, sans-serif;
  height: 40px;
  font-weight: 600;
  letter-spacing: 0.25px;
`

const StyledIcon = styled.img`
  height: 20px;
  min-width: 20px;
  width: 20px;
`

interface Props {
  callback?: () => void
}

// https://developers.google.com/identity/branding-guidelines
export const GoogleSignInButton: React.FC<Props> = ({ callback }) => {
  const { auth } = getServices()

  return (
    <StyledButton
      onClick={() => {
        callback?.()
        void auth.presentGoogleAuth()
      }}
    >
      <StyledIcon src={googleIcon} />
      <FormattedMessage {...strings.label} />
    </StyledButton>
  )
}
